module.exports = __webpack_public_path__ + "static/media/SDFSA_2-240w.aaebe95e.jpg";